<script lang="ts">
  import ProjectTemplate from "../../components/project-template.svelte";


</script>

<ProjectTemplate isEmbedded={false}>
    Loading
</ProjectTemplate>